export enum DIALOG_STYLE {
  'SM' = 'dialog-sm',
  'MD' = 'dialog-md',
  'LG' = 'dialog-lg',
  'XL' = 'dialog-xl',
  'FULL' = 'dialog-full',
  'FULL_HEIGHT' = 'dialog-full-height',
  'FULL_WIDTH' = 'dialog-full-width',
   /** Use when header has 1 extra line, other than the header title */
  'SM_HEADER_CONTENT' = 'dialog-sm-header-content',
  /** Use when header has 2 extra lines, other than the header title */
  'MD_HEADER_CONTENT' = 'dialog-md-header-content',
  /** Use when header has 3 extra lines, other than the header title */
  'LG_HEADER_CONTENT' = 'dialog-lg-header-content',
}
